import { USER_TYPES } from 'shared_DEPRECATED/types/User';

import { useUserMode } from './useUserMode';

export const useUserModeLabel = () => {
  const userMode = useUserMode();
  switch (userMode) {
    case USER_TYPES.COACH:
      return 'HDE';
    case USER_TYPES.ADMIN:
      return 'Admin';
    default:
      return 'Participant';
  }
};
